export default __webpack_public_path__ + "static/media/down.af04dce9.svg";